<input #imageFile type="file" accept="image/*" (change)="readImage(imageFile.files!)"/>
<button type="button" (click)="imageFile.click()" i18n-title title="Upload or take photo" i18n>📷️</button>
